var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#DBD6DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 20.8333C26.6666 25 23.7499 27.0833 20.2833 28.2916C20.1017 28.3531 19.9045 28.3502 19.7249 28.2833C16.2499 27.0833 13.3333 25 13.3333 20.8333V15C13.3333 14.779 13.421 14.567 13.5773 14.4107C13.7336 14.2544 13.9456 14.1666 14.1666 14.1666C15.8333 14.1666 17.9166 13.1666 19.3666 11.9C19.5431 11.7491 19.7677 11.6663 19.9999 11.6663C20.2321 11.6663 20.4567 11.7491 20.6333 11.9C22.0916 13.175 24.1666 14.1666 25.8333 14.1666C26.0543 14.1666 26.2662 14.2544 26.4225 14.4107C26.5788 14.567 26.6666 14.779 26.6666 15V20.8333Z",
    stroke: "#4A304A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminNav);
export default __webpack_public_path__ + "static/media/adminNav.1bd5468aaf8501f5513498925a18d2a7.svg";
export { ForwardRef as ReactComponent };